import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
const PrivateRoute = () => {
  const { authToken } = useSelector((store) => store.auth);
  return authToken !== null ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
